/*
    模块组件
    ChenYN

    说明
    主页底部切换栏

    版本
    1.0

    传参
    name Sting : 当前页面的name(同路由)

    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <Tabbar />
*/

<template>
    <Tabbar
        :model-value="name"
        @update:model-value="$emit('update:name', $event)"
        :active-color=activeColor
        inactive-color="#555555"
        class="tab_wrap"
        :border="false"
        :before-change="change"
        placeholder
    >
        <TabbarItem :dot="(isWechatMiniapp ? (isChuangyue ? index == 2 : index == 1) : (isChuangyue ? index == 3 : index == 2)) && dot" :name="v.name" v-for="(v, index) in tabList" :key="v.txt" @click="tabItemclick(v)">
            <span>{{ v.txt }}</span>
            <template #icon="props">
                <img :src="props.active ? v.active : v.un_active" />
            </template>
        </TabbarItem>
    </Tabbar>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, onBeforeMount, computed, onBeforeUnmount, watch } from 'vue';
import { Tabbar, TabbarItem } from "vant";
import router from "@/router"
import { useStore } from 'vuex';
import circleA from '@/assets/images/tab/circle_a.png';
import circleC from '@/assets/images/tab/circle_c.png';
import circleD from '@/assets/images/tab/circle_d.png';

import findA from '@/assets/images/tab/find_a.png';
import findD from '@/assets/images/tab/find_d.png';
import Util from '@/assets/js/lib/util';
import gameA from '@/assets/images/tab/game_a.png';
import gameC from '@/assets/images/tab/game_c.png';
import gameD from '@/assets/images/tab/game_d.png';

import welfareA from '@/assets/images/tab/welfare_a.png';
import welfareC from '@/assets/images/tab/welfare_c.png';
import welfareD from '@/assets/images/tab/welfare_d.png';

import strategyD from '@/assets/images/tab/strategy_d.png'
import strategyC from '@/assets/images/tab/strategy_c.png'

import mineA from '@/assets/images/tab/mine_a.png';
import mineD from '@/assets/images/tab/mine_d.png';
import mineC from '@/assets/images/tab/mine_c.png';

import goTop from '@/assets/images/common/goTop_btn.png'

export default defineComponent({
    name: 'TabbarCom',
    components: { Tabbar, TabbarItem },
    emits: ['goTop', 'update:name'],
    props: {
        name: {
            type: String,
            default: 'index'
        },
        goTopBtnShow: {
            type: Boolean,
            default: false
        },
        goTopBtnShow2: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { attrs, slots, emit }) {
        const { goTopBtnShow, goTopBtnShow2 } = toRefs(props);
        watch(goTopBtnShow2, (newval, oldval) => {
            if(newval) {
                if (state.sdkInfo.isSdkEnv || window.Config?.isSdk || state.isWechatMiniapp) {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else if(state.isWechatMiniapp && window.Config.platform == 'm9377'){
                        state.tabList = [
                            {
                                txt: '返回顶部',
                                un_active: gameD,
                                active: goTop,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                } else {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '返回顶部',
                                un_active: gameD,
                                active: goTop,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '返回顶部',
                                un_active: gameD,
                                active: goTop,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                }
            }else {
                if (state.sdkInfo.isSdkEnv || window.Config?.isSdk || state.isWechatMiniapp) {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else if(state.isWechatMiniapp && window.Config.platform == 'm9377'){
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                } else {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                }
            }
        })
        watch(goTopBtnShow, (newval, oldval) => {
            if(newval) {
                if (state.sdkInfo.isSdkEnv || window.Config?.isSdk || state.isWechatMiniapp) {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '返回顶部',
                                un_active: circleD,
                                active: goTop,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else if(state.isWechatMiniapp && window.Config.platform == 'm9377'){
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '返回顶部',
                                un_active: circleD,
                                active: goTop,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '返回顶部',
                                un_active: circleD,
                                active: goTop,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                } else {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ? gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '返回顶部',
                                un_active: circleD,
                                active: goTop,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ? gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '返回顶部',
                                un_active: circleD,
                                active: goTop,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                }
            }else {
                if (state.sdkInfo.isSdkEnv || window.Config?.isSdk || state.isWechatMiniapp) {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else if(state.isWechatMiniapp && window.Config.platform == 'm9377'){
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                } else {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                }
            }
        })
        const store = useStore();
        const state = reactive({
            util: new Util(),
            tabList: [],
            whiteList: ['index', 'game', 'find', 'welfare', 'mine', 'strategy'], //开放页面的白名单
            sdkInfo: computed(() => store.state.sdkInfo || {}),
            dot: computed(() => store.state.indexDot || false),
            isFirstDot: computed(() => store.state.isFirstDot || false),
            isWechatMiniapp: false, // 判断是否为微信小程序环境的变量
            activeColor: window.Config.platform == 'chuangyue' ? '#4DB7FF' : '#FF7F72',
            goTopBtnShow,
            goTopBtnShow2,
            isChuangyue: window.Config.platform == 'chuangyue' ? true : false,
        });

        const tabItemclick = (item) => {
            if((item.name == 'index' && state.goTopBtnShow) || (item.name == 'game' && state.goTopBtnShow2)) {
                emit('goTop');
            }
        }

        // 初始化 tabList 的安全方法
        const initTabList = async () => {
            try {
                let isAppClient = false;

                try {
                    isAppClient = state.util.isAPPClient();
                    console.log('state.util.isAPPClient():', isAppClient);
                } catch (error) {
                    console.error('检查是否为APP客户端失败:', error);
                    isAppClient = false;
                }

                if (isAppClient) {
                    try {
                        await state.util.getAppClient();
                    } catch (error) {
                        console.error('获取APP客户端信息失败:', error);
                    }
                }

                if (state.sdkInfo.isSdkEnv || window.Config?.isSdk || state.isWechatMiniapp) {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else if(state.isWechatMiniapp && window.Config.platform == 'm9377'){
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                } else {
                    if(window.Config.platform == 'chuangyue') {
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '攻略',
                                un_active: strategyD,
                                active: strategyC,
                                name: 'strategy'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }else {
                        state.tabList = [
                            {
                                txt: '首页',
                                un_active: gameD,
                                active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                                name: 'game'
                            },
                            {
                                txt: '福利',
                                un_active: welfareD,
                                active: window.Config.platform == 'chuangyue' ? welfareC : welfareA,
                                name: 'welfare'
                            },
                            {
                                txt: '圈子',
                                un_active: circleD,
                                active: window.Config.platform == 'chuangyue' ? circleC : circleA,
                                name: 'index'
                            },
                            {
                                txt: '我的',
                                un_active: mineD,
                                active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                                name: 'mine'
                            }
                        ];
                    }
                }
            } catch (error) {
                console.error('初始化 tabList 失败:', error);
                // 提供默认选项以防出错
                state.tabList = [
                    {
                        txt: '首页',
                        un_active: gameD,
                        active: window.Config.platform == 'chuangyue' ?  gameC : gameA,
                        name: 'game'
                    },
                    {
                        txt: '我的',
                        un_active: mineD,
                        active: window.Config.platform == 'chuangyue' ? mineC : mineA,
                        name: 'mine'
                    }
                ];
            }
        };

        onBeforeMount(async () => {
            // 判断是否在微信小程序环境
            state.isWechatMiniapp = await state.util.isWechatMiniapp();
            await initTabList();
        });

        onMounted(() => {
            try {
                reqUnread();
            } catch (error) {
                console.error('请求未读消息数据失败:', error);
            }
        });

        // 组件卸载前清理
        onBeforeUnmount(() => {
            // 可以在这里添加清理代码，如取消订阅、清除定时器等
        });

        const reqUnread = async () => { // 请求数据列表
            try {
                if (!state.isFirstDot) {
                    return; // 如果不是第一次，则不需要请求
                }

                // 判断是否第一次，只有第一次请求才能显示圈子红点
                const [res, res2] = await Promise.all([
                    state.util.getJson("/message/unread", "GET", {}, true),
                    state.util.getJson("/message/unreadOfficial", "GET", {}, true)
                ]);

                if (res?.code === 0) {
                    if (res.data) {
                        if (res.data.reply_count > 0 || res.data.like_count > 0 || res.data.invite_count > 0) {
                            store.commit('changeIndexDot', true);
                        }
                        store.commit('changeIsFirstDot', false);
                    }
                } else if (res) {
                    window.Components?.toast(res.msg);
                }

                if (res2?.code === 0) {
                    if (res2.data) {
                        for (const item of res2.data) {
                            if (item.unread > 0) {
                                store.commit('changeIndexDot', true);
                                break;
                            }
                        }
                    }
                } else if (res2) {
                    window.Components?.toast(res2.msg);
                }
            } catch (error) {
                console.error('获取未读消息失败:', error);
            }
        };

        const change = (e) => {
            try {
                if (state.whiteList.includes(e)) {
                    // 添加防御性延迟，防止DOM操作同步执行导致错误
                    setTimeout(() => {
                        router.push({name: e}).catch(err => {
                            console.warn('路由跳转失败，但已被捕获:', err);
                            // 失败时尝试使用替代方法
                            if (err.name !== 'NavigationDuplicated') {
                                try {
                                    window.location.href = router.resolve({name: e}).href;
                                } catch (e) {
                                    console.error('备用导航方法也失败:', e);
                                }
                            }
                        });
                    }, 0);
                    return true;
                } else {
                    window.Components?.toast('敬请期待...');
                    return false;
                }
            } catch (error) {
                console.error('切换页面失败:', error);
                return false;
            }
        };

        return {
            ...toRefs(state),
            change,
            tabItemclick
        };
    },
});
</script>
<style lang="less" scoped>
@import "./Tabbar.less";
</style>
